var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43384"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C0DAFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "w.ocredits",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8832 22.9811C23.3979 22.9283 21.3134 25.3131 21.8571 27.93C22.5184 31.114 26.4761 32.3153 28.791 30.0004C31.3739 27.4172 29.5363 22.9811 25.8832 22.9811ZM27.4785 25.7281C27.8486 25.3579 28.411 25.9203 28.0409 26.2905L25.5163 28.815C25.3611 28.9702 25.1091 28.9702 24.9539 28.815L23.7256 27.5868C23.3555 27.2166 23.9179 26.6542 24.288 27.0243L25.2352 27.9713L27.4785 25.7281ZM13.9187 24.8289C13.3949 24.8289 13.3949 24.0334 13.9187 24.0334H19.8075C20.3312 24.0334 20.3312 24.8289 19.8075 24.8289H13.9187ZM13.9187 21.9593C13.3949 21.9593 13.3949 21.1638 13.9187 21.1638H22.1632C22.687 21.1638 22.687 21.9593 22.1632 21.9593H13.9187ZM13.9187 19.0896C13.3949 19.0896 13.3949 18.2942 13.9187 18.2942H22.1632C22.687 18.2942 22.687 19.0896 22.1632 19.0896H13.9187ZM13.9187 16.22C13.3949 16.22 13.3949 15.4246 13.9187 15.4246H22.1632C22.687 15.4246 22.687 16.22 22.1632 16.22H13.9187ZM25.4856 22.2014C22.7558 22.4203 20.7163 24.8494 21.0027 27.6062H12.2899C11.3592 27.6062 10.5963 26.8435 10.5963 25.9126V12.5158H13.9187C14.1384 12.5158 14.3165 12.3376 14.3165 12.1179V8.79547H23.7923C24.723 8.79547 25.4856 9.55841 25.4856 10.4891V22.2014ZM21.1528 28.4017H12.2899C10.9203 28.4017 9.80078 27.2822 9.80078 25.9126V12.1179L9.92425 11.8299L13.6299 8.12427C13.7024 8.04773 13.8051 8 13.9187 8H23.7923C25.1616 8 26.2811 9.11947 26.2811 10.4891V22.2014C30.4227 22.5337 32.3134 27.6025 29.3534 30.5625C26.6851 33.2308 22.1464 31.9982 21.1528 28.4017ZM11.1589 11.7203H13.5211V9.35814L11.1589 11.7203Z",
    fill: "#0049A6",
    stroke: "#0049A6",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard8);
export default __webpack_public_path__ + "static/media/Card8.585d726d6f2aabd85f814415b16a5fd8.svg";
export { ForwardRef as ReactComponent };